export default "__VITE_ASSET__6eee81cd__"